import { render, staticRenderFns } from "./RequestAffectationBtnDialog.vue?vue&type=template&id=f4039036"
import script from "./RequestAffectationBtnDialog.vue?vue&type=script&lang=js"
export * from "./RequestAffectationBtnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports